export default __webpack_public_path__ + "static/media/ecommerce.4299efe6.png";